import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { LeadderboardEmbeddable } from '../components/leaderboard-embeddable';

export const PlayerAwardsLeaderboardEmbeddableProvider = ({ store, data }) => (
    <Provider store={store}>
        <LeadderboardEmbeddable {...data} />
    </Provider>
);

PlayerAwardsLeaderboardEmbeddableProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
